const ConsentCheckbox = ({ label, register, name, required }) => {
  return (
    <label className="flex items-start gap-3 cursor-pointer text-sm">
      {/* Checkbox */}
      <input
        type="checkbox"
        {...register(
          name,
          required && { required: "This consent is required" }
        )}
        className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
      />

      {/* Text */}
      <span className="leading-relaxed consultation-form-input block text-sm font-medium text-gray-900">
        {label}
      </span>
    </label>
  );
};

export default ConsentCheckbox;
